module.exports = __webpack_public_path__ + "static/media/take-picture-icon.51b83ec6.svg";